<!--
 * @Author: Jarun
 * @Date: 2021-03-22 17:06:11
 * @LastEditTime: 2021-04-12 10:46:52
 * @LastEditors: Please set LastEditors
 * @Description: Register
 * @FilePath: \box.mengw.com\src\views\Register\Register.vue
-->

<template>
    <div class="register_index" id="register">
        <LoginHeader />
        <div class="wrapper">
            <div class="content reg_bg">
                <LoginLogo />
                <div class="register_login_tab util_flex">
                    <span>
                        <p class="activeTxt">注册账号</p>
                        <b class="active"></b>
                    </span>
                </div>

                <Form class="register_login_form tips_wrap">
                    <div class="pr mb14">
                        <i class="register_input_icon_left icon_user"></i>
                        <Field
                            v-model.trim="username"
                            class="common_ring_btn"
                            label
                            placeholder="请输入账号"
                            autocomplete="off"
                            @focus="inputFocus('username')"
                        />
                        <!-- <div class="tips_msg">{{ tipsList.username }}</div> -->
                    </div>

                    <div class="pr mb14">
                        <PasswordInput
                            @changePassword="getPassword"
                            v-model="password"
                            placeholder="请输入密码"
                        />
                    </div>

                    <!-- <IdentifyingInput @changeMobile="getMobile" @changeCaptcha="getCaptcha" /> -->

                    <!-- <div class="pr mb14 mt14">
                        <i class="register_ver_icon_left real_name"></i>
                        <Field
                            v-model="realname"
                            class="common_ring_btn"
                            label
                            autocomplete="off"
                            placeholder="请输入姓名"
                        />
                    </div>

                    <div class="pr mb14 tips_wrap">
                        <i class="register_ver_icon_left ic_card"></i>
                        <Field
                            v-model="idcard"
                            class="common_ring_btn"
                            label
                            autocomplete="off"
                            placeholder="请输入身份证号"
                            @focus="inputFocus('idcard')"
                            @blur="inputBlur('idcard')"
                        />
                        <div class="ic_card_tips_msg">
                            姓名及身份证仅用于实名认证，不会泄露，请放心使用
                        </div>
                    </div> -->

                    <div class="pr mt21">
                        <div class="tncode"></div>
                    </div>

                    <div style="overflow: hidden">
                        <div v-on:click="onSubmit" class="c-button">注册并登录</div>
                    </div>
                </Form>
                <div class="register_agreement tips_wrap">
                    <check-agreement
                        v-model:checked="checked"
                        :changeCheck="agree"
                    ></check-agreement>
                    <!-- <div class="tips_msg agreement_tips">{{ tipsList.agreement }}</div> -->
                </div>
                <div class="go_login">已有账号，<span @click="goLinkLogin">前往登录</span></div>
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeMount, onUnmounted } from 'vue';
import '@/assets/less/common/tn_code.less';
import { Form, Field, Button } from 'vant';
import $TN from '@/assets/js/lib/tn_code.js';
import LoginHeader from '@/components/LoginHeader/LoginHeader.vue';
import PasswordInput from '@/components/PasswordInput/PasswordInput.vue';
import IdentifyingInput from '@/components/IdentifyingInput/IdentifyingInput.vue';
import Util from '@/assets/js/lib/util';
import router from '@/router';
import store from '@/store';
import CheckAgreement from '@/components/Seven_CheckAgreement/CheckAgreement.vue';
import BScroll from '@better-scroll/core'
import LoginLogo from '@/components/LoginLogo/LoginLogo.vue';

export default defineComponent({
    name: 'Register',
    components: {
        LoginHeader,
        LoginLogo,
        Form,
        Field,
        Button,
        PasswordInput,
        IdentifyingInput,
        CheckAgreement
    },
    setup(props, { attrs, slots }) {
        const state = reactive({
            username: '',
            password: '',
            mobile: '',
            captcha: '',
            offset: '',
            point_json: '',
            token: '',
            checked: true,
            Util: new Util(),
            title: '',
            content: '',
            realname: '', //姓名
            idcard: '', //身份证号
            tipsList: {
                username: '',
                password: '',
                mobile: '',
                realname: '',
                idcard: '',
                agreement: '',
            }
        });

        onBeforeMount(async () => {
        })

        onMounted(() => {
            $TN.init();
            $TN.onsuccess(function () {
                state.offset = this._mark_offset;
                state.point_json = this._point_json;
                state.token = this._token;
            });

            let scroll = new BScroll('.wrapper',{
                scrollY: true,
                click: true,
                bounceTime: 400,
                outOfBoundaryDampingFactor: 0.2,
                bounce: false,
            })
        });

        onUnmounted(() => {
            $TN.destroyed()
        })


        const agree = () => {
            state.checked = !state.checked;
            state.tipsList.agreement = '';
        }

        /* E 展示协议弹窗 */

        /* S 获取值 */
        const getPassword = (value) => {
            state.password = value;
        };

        const getMobile = (value) => {
            state.mobile = value;
        };

        const getCaptcha = (value) => {
            state.captcha = value;
        };
        /* E 获取值 */

        const toAgreement = () => {
        router.push({
            path: 'agreement',
        });
        };

        const setUserInfo = async (res) => {
            state.Util.setCookie("access_token", res.data.jwt_token);

            let result = await state.Util.refreshUserInfo();
            if(result.code !== 1){
                state.Util.login()
            }else{
                let arr = {
                    user: result.data.username,
                    pwd: state.password ? state.password : '',
                    nickName: result.data.nickname,
                    t: res.data.jwt_token,
                    vip: result.data.vip,
                    sex: result.data.sex,
                    en: 0
                }

                state.Util.setUserListLocalStorage('userList', arr);
            }

            store.commit('setUserInfo', result.data)

            state.Util.judgeJumpUrl();
        }

        const onSubmit = async () => {

            if (state.username == '') {
                window.Components.toast('请输入用户名');
                return false;
            }

            if (!state.Util.CSRegular().reguname(state.username)) {
                window.Components.toast('账号应为6~20位数字、字母或者下划线');
                return false;
            }

            if(state.password == ''){
                window.Components.toast('请输入密码');
                return false;
            }

            if (!state.Util.CSRegular().pass(state.password)) {
                window.Components.toast('密码应为6~32位数字、字母或特殊符号');
                return false;
            }

            // if (state.mobile == '') {
            //     window.Components.toast('请输入手机号');
            //     return false;
            // }

            // if (!state.Util.CSRegular().phone(state.mobile)) {
            //     window.Components.toast('请输入正确的手机号');
            //     return false;
            // }

            // if (!state.Util.CSRegular().captcha(state.captcha)) {
            //     window.Components.toast('请输入六位验证码');
            //     return false;
            // }

            if (state.point_json === '' || state.offset === '' || state.token === '') {
                window.Components.toast('请完成图形验证');
                return false;
            }

            // if (!state.isRealname && state.realname == '') {
            //     window.Components.toast("请输入姓名");
            //     return false;
            // }

            // if (!state.isRealname && state.idcard == '') {
            //     window.Components.toast("请输入身份证号");
            //     return false;
            // }

            // if (!state.isRealname && !state.Util.CSRegular().idcard(state.idcard)) {
            //     window.Components.toast('请输入正确的身份证号');
            //     return false;
            // }

            if (state.checked === false) {
                window.Components.toast('请先同意《平台用户协议》和《隐私政策》');
                state.tipsList.agreement = '*请先同意《平台用户协议》和《隐私政策》';
                return false;
            }

            window.Components.toast.loading({
                message: '注册中...',
                forbidClick: true,
                duration: 0,
                overlay:true
            })
            const { business_type, platform, game_id } = state.Util.getStatInfo();
            const param = {
                username: state.username,
                password: state.password,
                // mobile: state.mobile,
                // captcha: state.captcha,
                // target: state.target,
                // offset: state.offset,
                // realname: state.realname,
                // id_card: state.idcard,
                // game_id: report.gameid || '',
                game_id,
                // channel: report.channel || '',
                platform,
                business_type,
                is_h5: 1,
                // device_id: report.device_id || '',
                captcha_data: encodeURIComponent(JSON.stringify({
                    captcha_type: 1,
                    point_json: state.point_json,
                    token: state.token
                }))
            };
            state.Util.clickStat('register_click', {
                register_type: '1',
                account: state.username,
                uid: '',
                phone: '',
                gameid: game_id,
            });
            const res = await state.Util.getUserJson('/user/register', 'POST', param, false);

            if (res.code === 1) {
                const param = {
                    username: state.username,
                    password: state.password,
                    login_save:1,
                    business_type,
                    game_id,
                    platform,
                    is_h5: 1,
                };
                const loginRes = await state.Util.getUserJson('/user/login', 'POST', param, false);
                window.Components.toast.clear();
                if (loginRes.code === 1) {
                    window.Components.toast('注册成功');
                    setUserInfo(loginRes);
                    state.Util.statsLogin(1); //登录行为上报
                // }else if([-4, -2].includes(loginRes.code)){
                //     state.tipsList.username = '*'+ loginRes.msg;
                //     window.Components.toast(loginRes.msg);
                }else {
                    window.Components.toast(loginRes.msg);
                }
                // setUserInfo(res);
                // state.Util.statsLogin(1); //登录行为上报
            // }else if(res.code == 40046){
            //     $TN.destroyed();
            //     setTimeout(() => {
            //         $TN.init();
            //     }, 100);
            //     window.Components.toast(res.msg);
            }else{
                window.Components.toast(res.msg);
                resetTN();
            }
        };

        const resetTN = () => {
            $TN.destroyed();
            if(state.isRefreshCode){
                $TN.refresh();
            }
            setTimeout(() => {
                $TN.init();
                state.token = '';
                state.offset = '';
                state.point_json = '';
            }, 100);
        };

        const inputFocus = (type) => {
            state.tipsList[type] = '';
        };
        const inputBlur = (type) => {
            if(state[type] == '') return false;
            let list = {
                username: '*此账号已存在',
                realname: '',
                idcard: '*请输入正确的身份证号码',
            };
            if(!state.Util.CSRegular()[type](state[type])){
                state.tipsList[type] = list[type];
            }
        };
        const golinkKefu = () => {
            router.push({name: 'customercenter'})
        };

        const goLinkLogin = () => {
            state.Util.login({ query: router.currentRoute.value.query }, 'replace')

        }

        return {
            onSubmit,
            getCaptcha,
            getMobile,
            getPassword,
            toAgreement,
            agree,
            inputFocus,
            inputBlur,
            golinkKefu,
            goLinkLogin,
            ...toRefs(state),
        };
    },
});
</script>

<style lang="less" scoped>
@import "@/assets/less/common/register.less";
</style>
